import { useContext } from 'react';
import { UserSupervisionFiltersContext } from '@/components/contexts/UserSupervisionFiltersContext/UserSupervisionFiltersProvider';

export const useUserSupervisionFilters = () => {
    return useContext(UserSupervisionFiltersContext);
};
